import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {PageNotFoundComponent} from './shared/components/page-not-found/page-not-found.component';
import {DashboardModule} from './dashboard/dashboard.module';
import {AuthGuard} from './shared/guards/auth.guard';
import {AuthModule} from './auth/auth.module';
import {InventoryModule} from './inventory/inventory.module';
import {ReportsModule} from './reports/reports.module';
import {TeamModule} from './team/team.module';
import {SettingsModule} from './settings/settings.module';
import {ConstructorModule} from './constructor/constructor.module';
import {BaseComponent} from './base/base.component';
import {AdminGuard} from './shared/guards/admin.guard';
import { environment } from 'src/environments/environment';
import { AuditsModule } from './audits/audits.module';
import { AccountUnderReviewModule } from './account-under-review/account-under-review.module';
import { MessagesModule } from './messages/messages.module';

const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.module').then(m => AuthModule),
  },
  {
    path: '',
    component: BaseComponent,
    canActivate: [AuthGuard],
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      {
        path: 'constructor',
        loadChildren: () => import('./constructor/constructor.module').then(m => ConstructorModule),
      },
      {
        path: 'dashboard',
        loadChildren: () => import('./dashboard/dashboard.module').then(m => DashboardModule),
      },
      {
        path: 'inventory',
        loadChildren: () => import('./inventory/inventory.module').then(m => InventoryModule),
      },
      {
        path: 'audits',
        loadChildren: () => import('./audits/audits.module').then(m => AuditsModule),
      },
      {
        path: 'reports',
        loadChildren: () => import('./reports/reports.module').then(m => ReportsModule),
      },
      {
        path: 'team',
        canActivate: [AdminGuard],
        loadChildren: () => import('./team/team.module').then(m => TeamModule),
      },
      {
        path: 'settings',
        canActivate: [AdminGuard],
        loadChildren: () => import('./settings/settings.module').then(m => SettingsModule),
      },
      {
        path: 'messages',
        loadChildren: () => import('./messages/messages.module').then(m => MessagesModule),
      },
    ],
  },
  {
    path: '404', component: PageNotFoundComponent,
  },
  {
    path: 'account-under-review', loadChildren: () => import('./account-under-review/account-under-review.module').then(m => AccountUnderReviewModule),
   // path: 'account-under-review', component: AccountUnderReviewComponent,
    pathMatch: 'full'
  },
  {path: '**', redirectTo: '404'},
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {enableTracing: environment.enableRouteTracing})],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
